(function () {
    angular.module('tbg.errorReporting', []);
}());
